export default {
	best: parseInt(localStorage.getItem('best')) || 0,
	value: 0,
	reset: function () {
		this.value = 0;
	},
};
